import TaskManagerEditDto from './TaskManagerEditDto';

export class OutlierDetectionTaskEditDto extends TaskManagerEditDto {
    constructor() {
        super();

        /** @type {number} */
        this.measurement = null;

        /** @type {number[]} */
        this.outlierDetectors = null;
    }

    /**
     * @typedef {Object} _OutlierDetectionTaskEditDto Props
     * @property {number} measurement
     * @property {number[]} outlierDetectors
     *
     * @typedef {import("./TaskManagerEditDto").TaskManagerEditDtoProps & _OutlierDetectionTaskEditDto Props} OutlierDetectionTaskEditDto Props
     */
    /**
     *
     * @param {OutlierDetectionTaskEditDto Props} props
     * @returns {OutlierDetectionTaskEditDto }
     */
    setup(props) {
        super.setup(props);

        this.measurement = props.measurement;
        this.outlierDetectors = props.outlierDetectors !== null ? props.outlierDetectors : [];

        return this;
    }
}

export default OutlierDetectionTaskEditDto;